"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  textFieldRoot: {
    minHeight: '40px',
    fontSize: '1em',
    zIndex: 0
  },
  inputLabelRoot: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.54)',
    '&:focused': {
      color: theme.palette.custom.grey ? theme.palette.custom.grey.dark : undefined
    },
    fontSize: '1.10rem',
    padding: theme.spacing(1, 0, 0, 2),
    width: 'calc(100% * (4/3))',
    zIndex: 1,
    backgroundColor: theme.palette.custom.grey ? theme.palette.custom.grey.light : undefined
  },
  inputRoot: {
    minHeight: '30px',
    fontSize: '1em',
    padding: theme.spacing(1, 0, 0, 0.5),
    backgroundColor: theme.palette.custom.grey ? theme.palette.custom.grey.light : undefined
  },
  input: {
    paddingLeft: theme.spacing(1),
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '1em'
  },
  inputMultiline: {
    paddingTop: '10px'
  },
  helperText: {
    fontSize: '0.7rem',
    backgroundColor: 'none'
  }
}), {
  name: 'TextField'
});
var _default = exports.default = useStyles;